import React, { useEffect, useState } from "react";
import { ListPage } from "../ListPage";
import config from "../../config";
import * as API from "../../helpers/api";
import NProgress from "nprogress";
import { useLang } from "../../helpers/language";
import { Image, useMantineColorScheme } from "@mantine/core";
import moment from "moment";

const parsePhoneNumber = (number) => {
	return `+374${number.split(/[-*\/\s]+/).join("")}`;
};

const getUniqueClientNameOptions = (clients) =>
	[...new Set(clients.map((client) => client.name).filter(Boolean))].map((name) => ({
		value: name,
		label: name,
	}));

export default function ClientList() {
	const { lang } = useLang();
	const { colorScheme } = useMantineColorScheme();
	const [clients, setClients] = useState([]);
	const [isBusy, setBusy] = useState(true);
	const [columns, setColumns] = useState([]);

	function setRefreshColumns() {
		return [
			{
				accessorKey: "index",
				header: config.translate.index[lang],
				permissionModel: "index",
				size: 30,
			},
			{
				accessorKey: "name",
				permissionModel: "name",
				header: config.translate.name[lang],
				filterVariant: "select",
				mantineFilterSelectProps: {
					data: getUniqueClientNameOptions(clients),
					searchable: true,
				},
				Cell: (
					RecievedObject,
					cell = RecievedObject.renderedCellValue,
					row = RecievedObject.row.original
				) => {
					let result = row.name ? row.name : "...";
					return result;
				},
			},
			{
				accessorKey: "phone",
				permissionModel: "phone",
				enableColumnActions: false,
				header: config.translate.more[lang],
				Cell: (
					RecievedObject,
					cell = RecievedObject.renderedCellValue,
					row = RecievedObject.row.original
				) => {
					let result = "";
					if (row.phone && row.phone?.length > 0)
					{
						result = (
							<div
								className="icon-comment-wrapper"
								style={{
									display: "flex",
									justifyContent: "space-between",
								}}
							>
								<a
									style={{ marginRight: "40px" }}
									href={`tel:${parsePhoneNumber(row.phone)}`}
								>
									<Image
										w="20"
										h="20"
										className="icon-comment"
										src="/assets/phone-call-svgrepo-com.svg"
										alt="phone"
										style={{
											filter: colorScheme === "dark" ? "invert(1)" : "",
										}}
									/>
								</a>
								<a style={{ marginRight: "40px" }} href={`mailto:${row.email}`}>
									<Image
										w="20"
										h="20"
										className="icon-comment"
										src="/assets/email-svgrepo-com.svg"
										alt="email"
										style={{
											filter: colorScheme === "dark" ? "invert(1)" : "",
										}}
									/>
								</a>
							</div>
						);
					}
					return result;
				},
			},
			{
				accessorKey: "debtBalance",
				permissionModel: "debt",
				header: config.translate.debt[lang],
				filterVariant: "range",
				filterFn: "between",
				size: 200,
				Cell: (
					RecievedObject,
					cell = RecievedObject.renderedCellValue,
					row = RecievedObject.row.original
				) => {
					return new Intl.NumberFormat("en-US").format(Math.round(row.debtBalance || 0));
				},
			},
		];
	}

	useEffect(() => {
		NProgress.start();
		(async () => {
			const rawClients = await API.get(config.api.client, null, null, null, null, null, null, false, [
				"_id",
				"name",
			]);
			if (rawClients) setClients(rawClients);

			setColumns(setRefreshColumns());

			setBusy(false);
		})();
		// eslint-disable-next-line
	}, [isBusy]);

	useEffect(() => {
		setColumns(setRefreshColumns());
		// eslint-disable-next-line
	}, [lang, colorScheme, clients]);

	if (!isBusy && columns.length > 0)
		return (
			<ListPage
				route={config.api.client}
				sorting={{ name: 1 }}
				permissionModel={"client"}
				uploadType={null}
				limit={null}
				columns={columns}
				pageSize={25}
			/>
		);
}
